export const extractTenants = lease => {
  if (!lease || lease === {}) return [];

  return lease.cotenants.map(cotenant => {
    return {
      label: cotenant.full_name,
      value: cotenant.lead_id || cotenant.occupant_id,
    };
  });
};
